import {TOKEN_PROGRAM_ID, TOKEN_2022_PROGRAM_ID} from '@solana/spl-token';
import {PublicKey} from '@solana/web3.js';

export const getSolanaTokenProgramId = (currency: string): PublicKey => {
  switch (currency.toLowerCase()) {
    case 'usdc':
    case 'usdp':
      return TOKEN_PROGRAM_ID; // Legacy SPL Token Program
    case 'usdg':
      return TOKEN_2022_PROGRAM_ID; // SPL Token 2022 Program
    case 'cash':
    case 'phantom_cash':
      return TOKEN_2022_PROGRAM_ID; // SPL Token 2022 Program
    default:
      throw Error(`Invalid solana currency: ${currency}`);
  }
};

export default getSolanaTokenProgramId;
